import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import { GetContract } from "../../services/Api/contract";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import Item from "./components/Item";
import Options from "./components/Options";

export default function ContractList({ navigation, route }) {
    const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
    const [contractList, setContractList] = useState([])
    const [contractInfo, setContractInfo] = useState({})

    useEffect(() => setLoading({
        show: true,
        message: "Carregando contratos",
    }), [])

    const [modalVisible, setModalVisible] = useState(false)
    const [idContractSelected, setIdContractSelected] = useState(false)

    const onPressOption = (idContract) => {
        setIdContractSelected(idContract)
        setModalVisible(!modalVisible)
    }

    useEffect(() => {
        GetContract().then((value) => {
            setContractList(value.data.vacancy)
            delete value.data.vacancy
            setContractInfo(value.data)
        }).catch((value) => {
            setShowAlert({
                type: "alert",
                title: "Ooops",
                message: value.erro ? value.erro : "Não informado",
                show: true,
                confirmText: "OK",
                pressConfirm: () => {
                    setShowAlert({ ...showAlert, show: false });
                },
            });
        }).finally(() => setLoading(true))
    }, [])

    return <PageTitle title={"CONTRATOS"} navigation={navigation}>
        <ScrollView
            style={styles.viewSecundaria}
            contentContainerStyle={{
                alignItems: "center",
                paddingBottom: 8,
                flexGrow: 1,
            }}
        >
            {contractList.length > 0 ?
                contractList.map((value, index) => {
                    return <Item
                        item={value}
                        key={value.contract}
                        onPressOptions={onPressOption}
                    />
                })
                : <View
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        flex: 1,
                        flexGrow: 1,
                    }}
                >
                    <Icon name="file-clock" size={128} color={Colors.BLACK} />
                    <Text style={{ marginTop: 24, fontSize: Fonts.FONT_SIZE_16 }}>
                        {"Nenhum contrato encontrado"}
                    </Text>
                </View>}
        </ScrollView>
        <Options
            setModalVisible={setModalVisible}
            modalVisible={modalVisible}
            idContract={idContractSelected}
            navigation={navigation} />
    </PageTitle>
}

const styles = StyleSheet.create({
    viewSecundaria: {
        backgroundColor: Colors.WHITE,
        width: "100%",
        flex: 1,
        flexGrow: 1,
    },
});